import React, {
  createContext,
  useContext,
  useRef,
  useState,
  useCallback
} from 'react'

/**
 * GlobalModalProvider
 * Zarządza wieloma modalami jednocześnie.
 * API open(Component, props) -> { id, close }
 * Każdy Component otrzyma propsy: open (true), close() oraz własne przekazane.
 */
const GlobalModalContext = createContext(null)

export const GlobalModalProvider = ({ children }) => {
  const [modals, setModals] = useState([])
  const idRef = useRef(1)

  const close = useCallback(id => {
    setModals(prev => prev.filter(m => m.id !== id))
  }, [])

  const open = useCallback(
    (Component, props = {}) => {
      const id = idRef.current++
      setModals(prev => [...prev, { id, Component, props }])
      return { id, close: () => close(id) }
    },
    [close]
  )

  return (
    <GlobalModalContext.Provider value={{ open, close }}>
      {children}
      {modals.map(({ id, Component, props }) => (
        <Component key={id} open close={() => close(id)} {...props} />
      ))}
    </GlobalModalContext.Provider>
  )
}

export const useGlobalModal = () => {
  const ctx = useContext(GlobalModalContext)
  if (!ctx)
    throw new Error(
      'useGlobalModal musi być użyty wewnątrz GlobalModalProvider'
    )
  return ctx
}
